export default __webpack_public_path__ + "static/media/Group54.60cb185e.svg";